export { default } from './RibbonStarTwo'
